export enum AuthErrorType {
  LOGIN_REQUIRED = 'login_required',
  INVALID_TOKEN = 'invalid_token',
  SLUG_IS_EMPTY = 'empty_slug',
  UNAUTHORIZED = 'unauthorized',
  TIMEOUT = 'timeout',
}
